import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "wasp/client/operations";
import { getVisibleSections } from "wasp/client/operations";
import { useLocationContext } from "../contexts/LocationContext";
import type { SectionKey } from "../../gedoba/location-types/constants";

/**
 * Redirects to dashboard if the given section is hidden (globally or for current location).
 * Use on section list, add, edit and view pages (e.g. RetailPage, AddJobPage).
 */
export function useRequireSectionVisible(sectionKey: SectionKey) {
  const navigate = useNavigate();
  const { selectedLocation } = useLocationContext();
  const { data, isLoading } = useQuery(getVisibleSections, {
    locationId: selectedLocation?.id ?? null,
  });
  const visibilityData = data as
    | { visibleByKey?: Record<string, boolean> }
    | undefined;
  const visibleByKey = visibilityData?.visibleByKey ?? {};

  useEffect(() => {
    if (isLoading) return;
    if (visibleByKey[sectionKey] === false) {
      navigate("/dashboard", { replace: true });
    }
  }, [sectionKey, visibleByKey, isLoading, navigate]);
}
